import React from 'react'
import ListUser from './ListUser'
import { Box, Skeleton } from '@mui/material'

function ListParticipantsShare({userListRender, setChangeDataParticipant, displayCloseIcon, t, className="share-subtitle-content-participant", ...props}) {
  return (
    <div className={className} {...props} >
      {
        userListRender ?
        (
          userListRender?.length > 0 ?
          (
            <ListUser 
              dataParticipants={userListRender} 
              setChangeDataParticipant={setChangeDataParticipant} 
              displayCloseIcon={displayCloseIcon}
            />
          ) 
          :
          (
            <Box sx={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>{t('subtitles.table.no-data')}</Box>
          )
        ) 
        :
        (
          <Box sx={{display: 'flex', width: '100%', flexDirection: 'column'}}>
              <Skeleton sx={{width: '80%', marginLeft: '10px'}}/>
              <Skeleton sx={{width: '80%', marginLeft: '10px'}}/>
              <Skeleton sx={{width: '80%', marginLeft: '10px'}}/>
          </Box>
        )
      }
        
    </div>
  )
}

export default ListParticipantsShare